import { JSX } from "react";
import apiClient from "../apiClient";

const baseUrl = '/doc/menus'

export type MenuStatus = 'enabled' | 'disabled';

export type DocMenuItem = {
    _id: string;
    name: string;
    code: string;
    path: string;
    component?: string;
    layout?: boolean;
    icon?: JSX.Element;
    order?: number;
    description?: string;
    status: MenuStatus;
    createdAt?: string;
    updatedAt?: string;
};

export async function getDocMenus(params: Record<string, any> = {}) {
    return apiClient<{
        list: DocMenuItem[]; total: number;
    }>(baseUrl, {
        method: 'GET',
        params,
    });
}

export async function addDocMenu(data: Partial<DocMenuItem>) {
    return apiClient(baseUrl, {
        method: 'POST',
        data,
    });
}

export async function updateDocMenu(id: string, data: Partial<DocMenuItem>) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'PUT',
        data,
    });
}

export async function deleteDocMenu(id: string) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'DELETE',
    });
}
